import {
  canvasConverter,
  componentConverter,
  operatingConditionConverter,
} from '@seu-converter';
import {
  SeuApiConverter,
  SeuInterconnection,
  SeuInterconnectionApi,
} from '@seu-types';

export const interconnectionConverter: SeuApiConverter<
  SeuInterconnection,
  SeuInterconnectionApi
> = {
  fromApi: (input) => {
    const interconnection: SeuInterconnection = {
      ...input,
      id: String(input.id),
      name: input.name ?? '',
      components:
        input.components?.map((dto) => {
          return componentConverter.fromApi(dto);
        }) ?? [],
      operatingConditions:
        input.operatingConditions?.map((dto) => {
          return operatingConditionConverter.fromApi(dto);
        }) ?? [],
      canvas: canvasConverter.fromApi(input.canvas),
    };
    return interconnection;
  },
  toApi: (input) => {
    const interconnection: SeuInterconnectionApi = {
      ...input,
      id: Number(input.id),
      components: input.components.map((component) => {
        return componentConverter.toApi(component);
      }),
      operatingConditions: input.operatingConditions.map(
        (operatingCondition) => {
          return operatingConditionConverter.toApi(operatingCondition);
        }
      ),
      canvas: canvasConverter.toApi(input.canvas),
    };
    return interconnection;
  },
};
